module.exports = __webpack_public_path__ + "static/assets/99bec0bf0429ebaafab900f617f83ba4.png";